/**
 * ネストされたメッセージをフラットなオブジェクトに変換する関数
 * @param {Object} nestedMessages - ネストされたメッセージ
 * @param {string} prefix - プレフィックス
 * @returns {Object} フラットなメッセージ
 */
const flattenMessages = (nestedMessages, prefix = '') => {
  const messages = {};

  Object.keys(nestedMessages).forEach(key => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }
  });

  return messages;
};

export default flattenMessages;
